import { createConfigSelector } from '@americanexpress/travel-selectors';
import { createSelector } from 'reselect';
import { getLang } from '@/helpers/utils';
import { getLocaleData } from './localeSelectors';

export const getBdaasUrl = createConfigSelector('bdaasUrl');
// auth key needed to call the BDaaS Intranet Service, not needed for BDaaS Internet Service at this time
export const getBdaasAuthKey = createConfigSelector('bdaasAuthKey');

// needed temporarily for the argentina centurion card until THE_CENTURION_CARD_ES_AR is added to BDAAS
export function getProduct(product, locale) {
  // needed for temporarily for the card switcher page (no product in url)
  if (!product) {
    return 'the-platinum-card';
  }

  if (product === 'the-centurion-card' && locale === 'es-AR') {
    return 'the-centurion-card-argentina';
  }
  return product;
}

export const getBdaasAirportsUrl = (product) => (state) => {
  const { locale } = getLocaleData(state);
  const baseUrl = getBdaasUrl(state);
  return `${baseUrl}/airports?product=${getProduct(product, locale)}&locale=${locale}&lang=${getLang(
    locale
  )}`;
};

export const getBdaasAirportLoungesUrl = ({ product, airportCode }) =>
  createSelector(
    getBdaasUrl,
    getLocaleData,
    (baseUrl, { locale }) =>
      `${baseUrl}/airports/${airportCode}/lounges?product=${getProduct(product, locale)}&locale=${locale}&lang=${getLang(
        locale
      )}&purchasable=true`
  );

export const getBdaasUserLoungeBookingUrl = createSelector(
  getBdaasUrl,
  (baseUrl) => `${baseUrl}/lounges/booking`
);
